import { trackPageView} from '../../utlis/useAnalytics';
import { useEffect } from 'react';
import {PageName} from '../../configs/config'
import { Helmet } from "react-helmet-async";
export default function Contactus() {
  useEffect(() => {
    trackPageView(PageName.ContactUs);
  }, []);

  // Company contact information
  const contactInfo = {
    address: "1st Floor, 592, Nomads Centre, 1st Cross Rd, Santhosapuram, Koramangala 3 Block, Koramangala, Bengaluru, Karnataka 560034",
    email: "connect@eximpe.com",
    phone: "(+91) 6909016944",
    mapUrl: "https://www.google.com/maps/uv?pb=!1s0x3bae15be2e8e9a0d%3A0xb7e7d0d3ba697080!3m1!7e115!4s%2Fmaps%2Fplace%2FEximPe%2F%4012.9275222%2C77.6214072%2C3a%2C75y%2C37.9h%2C90t%2Fdata%3D*213m4*211e1*213m2*211s1NBCSlvKNBHit_7GopA6aw*212e0*214m2*213m1*211s0x3bae15be2e8e9a0d%3A0xb7e7d0d3ba697080%3Fsa%3DX%26ved%3D2ahUKEwjsgfnw2pCMAxWtyTgGHcJyGLoQpx96BAgdEAA!5sEximPe%20-%20Google%20Search!15sCgIgAQ&imagekey=!1e2!2s1NBCSlvKNBHit_7GopA6aw&cr=le_a7&hl=en&ved=1t%3A206134&ictx=111",
    embedMapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15545.886439239654!2d77.6214072!3d12.9275222!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15be2e8e9a0d%3A0xb7e7d0d3ba697080!2sEximPe!5e0!3m2!1sen!2sin!4v1681867295352!5m2!1sen!2sin"
  };

  return (
     <><Helmet>
      <title>Contact EximPe – Get in Touch for Global Payment Solutions</title>
      <meta name="description" content="Have questions or need support? Contact EximPe to learn more about our cross-border payments, trade accounts, or financing solutions. We’re here to help." />
    </Helmet>
    <div className="contact-page text-[#1A202C] lg:px-[10%] ">
        {/* Page Header */}
        <div className="mt-[140px] mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-center text-black">Contact Us</h1>
          <p className="text-[#6a7282] text-center text-xl md:text-2xl mt-5">
            Let's navigate the global trade landscape together
          </p>
        </div>

        {/* Contact Information Section */}
        <div className="flex flex-col md:flex-row items-center justify-center mt-10 gap-6 mb-10 px-4">
          {/* Contact Details */}
          <div className="w-full md:w-1/2 space-y-5">
            <div>
              <h2 className="font-bold text-xl md:text-2xl">Address</h2>
              <p className="text-[#6a7282]">{contactInfo.address}</p>
            </div>

            <div>
              <h2 className="font-bold text-xl md:text-2xl">Email Us</h2>
              <a
                href={`mailto:${contactInfo.email}`}
                className="hover:text-[#169a86] text-[#6a7282] transition-colors"
              >
                {contactInfo.email}
              </a>
            </div>

            <div>
              <h2 className="font-bold text-xl md:text-2xl">Call Us</h2>
              <a
                href={`tel:${contactInfo.phone.replace(/[()\s-]/g, '')}`}
                className="hover:text-[#169a86] text-[#6a7282] transition-colors"
              >
                {contactInfo.phone}
              </a>
            </div>
          </div>

          {/* Interactive Google Map */}
          <div
            className="w-full md:w-[500px] h-[300px] md:h-[400px] border border-gray-300 shadow-lg rounded-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
            onClick={() => window.open(contactInfo.mapUrl, "_blank")}
            aria-label="Open EximPe location in Google Maps"
            role="button"
            tabIndex={0}
          >
            <iframe
              title="EximPe Office Location"
              src={contactInfo.embedMapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </div></>
  );
}